module.exports = __webpack_public_path__ + "static/MenuLogo-e9b3b15521ca97dc78404518cb540931.svg";